import React, { useEffect, useState } from "react";
import LineBg from "../../assets/images/line-bg.png";
import { Link } from "react-router-dom";
import propertyService from "../../services/propertyService";
import FooterSEOLinkServices from "../../services/footer-seo-link.service"
import {
  faInstagram,
  faYoutube,
  faFacebookF,
  faLinkedinIn,
  faRedditAlien,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Maps a pageType group -> { heading, linkPrefix }
// linkPrefix is used to build the visible link text: `${linkPrefix} in {locationName}`
const FOOTER_SECTIONS = [
  {
    pageType: "rooms-for-rent",
    heading: "Rooms for Rent in Bangalore",
    linkPrefix: "Room for rent",
  },
  {
    pageType: "flats-for-rent",
    heading: "Flats for Rent in Bangalore",
    linkPrefix: "Flats for rent",
  },
  {
    pageType: "no-brokerage-flats-for-rent",
    heading: "No brokerage flats for rent",
    linkPrefix: "No brokerage flats for rent",
  },
  {
    pageType: "no-commission-flats-for-rent",
    heading: "No commission flats for rent",
    linkPrefix: "No commission flats for rent",
  },
];

const MAX_LINKS_PER_COLUMN = 9;

const Footer = () => {
  const [footerGroups, setFooterGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFooterLinks = async () => {
      try {
        const response = await FooterSEOLinkServices.getFooterLinks();
        setFooterGroups(response?.data?.result || []);
      } catch (error) {
        console.error("Failed to fetch footer links", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFooterLinks();
  }, []);

  // Pull links for a given pageType, drop city-only entries (empty locationName),
  // and cap the count for the column.
  const getLinksForPageType = (pageType) => {
    const group = footerGroups.find((g) => g.pageType === pageType);
    if (!group?.links) return [];
    return group.links
      .filter((link) => link.locationName && link.locationName.trim() !== "")
      .slice(0, MAX_LINKS_PER_COLUMN);
  };

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="row row-gap-gutter">
            {FOOTER_SECTIONS.map((section) => {
              const links = getLinksForPageType(section.pageType);
              return (
                <div
                  key={section.pageType}
                  className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6"
                >
                  <div className="footer-widget-list">
                    <div className="footer-content-heading">
                      <h4>{section.heading}</h4>
                    </div>
                    <ul>
                      {links.map((link) => (
                        <li key={link.id}>
                          <Link
                            target="_blank"
                            rel="noopener noreferrer"
                            to={`rent/${link.url}`}
                          >
                   {`${section.linkPrefix} in ${link.locationName.charAt(0).toUpperCase()}${link.locationName.slice(1)}`}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              );
            })}

            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6  col-6 tab-show footer-tab-about footer-main-links">
              <div className="footer-widget-list">
                <div className="footer-content-heading">
                  <h4>About</h4>
                </div>
                <ul>
                  <li>
                    <Link to="about-us">About</Link>
                  </li>
                  <li>
                    <Link to="blogs">Blogs</Link>
                  </li>
                  <li>
                    <Link to="faq">Faq</Link>
                  </li>
                  <li>
                    <Link to="terms-conditions">Terms &amp; Conditions</Link>
                  </li>
                  <li>
                    <Link to="privacy-policy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="cancellation-policy">Cancellation Policy</Link>
                  </li>
                  <li>
                    <Link to="contact-us">Contact Us</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <div className="social-media-container">
              <span className="social-title">Follow Us On:</span>

              <div className="social-icons-wrap d-flex gap-2">
                <div className="social-icon instagram" title="Instagram">
                  <a
                    href="https://www.instagram.com/we.rentt/"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faInstagram} />
                  </a>
                </div>

                <div className="social-icon youtube " title="Youtube">
                  <a
                    href="https://www.youtube.com/@werentt"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faYoutube} />
                  </a>
                </div>

                <div className="social-icon facebook" title="Facebook">
                  <a
                    href="https://facebook.com/werentt1"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faFacebookF} />
                  </a>
                </div>

                <div className="social-icon linkedin" title="LinkedIn">
                  <a
                    href="https://www.linkedin.com/company/werentt/"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faLinkedinIn} />
                  </a>
                </div>

                <div className="social-icon reddit" title="Reddit">
                  <a
                    href="https://www.reddit.com/user/werentt_official/"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faRedditAlien} />
                  </a>
                </div>
              </div>
            </div>
            <div className="right-content">
              <ul>
                <li>
                  <Link to="terms-conditions">Terms &amp; Conditions</Link>
                </li>
                <li>
                  <Link to="privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="cancellation-policy">Cancellation Policy</Link>
                </li>
                <li>
                  <Link to="rent-sitemap">SiteMap</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright-bottom">
        <div className="container">
          <div className="copyright">
            <p className="my-1">&copy; A Unit of SoWeRent Technologies LLP</p>
            <p>
              Copyright 2026 - All right reserved WeRentt | Developed by{" "}
              <Link
                className="orange-link"
                to="https://www.nextwebi.com/"
                target="_blank"
              >
                Nextwebi
              </Link>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;